export default "__VITE_ASSET__B7xYmw5o__"